import { useEffect, useSyncExternalStore } from "react";
import { authStore } from "../util/authStore";

export default function useAuth() {
  const state = useSyncExternalStore(authStore.subscribe, authStore.getSnapshot);
  useEffect(() => { authStore.initialize(); }, []);
  return { ...state, can: authStore.can, refresh: authStore.refresh, switchClient: authStore.switchClient };
}
